import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionPendingPage } from '../../pages/SubscriptionPendingPage';
import { subscriptionPendingSearchSchema } from '../../routing/schemas';

export const Route = createFileRoute('/_private/subscription-pending')({
  validateSearch: subscriptionPendingSearchSchema,
  component: SubscriptionPendingRoute,
});

function SubscriptionPendingRoute() {
  const { apiClient } = Route.useRouteContext();
  return <SubscriptionPendingPage portalApiClient={apiClient} />;
}
